export function buildCommercialColorByName(commerciaux = []) {
  const map = {};
  commerciaux.forEach((c) => {
    if (c.nom) map[c.nom] = c.couleur;
    if (c.email) map[c.email] = c.couleur;
  });
  return map;
}

export function getCommercialColor(colorByName, name) {
  if (!name || !colorByName) return null;
  return colorByName[name] ?? null;
}
